module.exports = __webpack_public_path__ + "static/media/beaute.dabe82e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beaute.jpg
// module id = 1162
// module chunks = 0